import React from 'react';

import { ManagementFieldDisplay } from '@components/ManagementFieldDisplay';
import { CommodityPhotoCover } from '@components/utilities/Commodity/CommodityPhotoCover';
import { commodityStrings } from '@data/commodities';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import type { Commodity } from '@models/next/Commodity';
import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexInline,
    alignItems: 'stretch',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey[50],
    width: '100%',
    minHeight: 376,
    overflow: 'hidden',
  },
  mainCol: {
    flex: 1,
    ...common.flexColumn,
    padding: '22px 48px 22px 30px',
    overflow: 'hidden',
  },
  previewBoxCol: {
    ...common.flexColumn,
    width: '250px',
    paddingTop: '32px',
    alignItems: 'flex-end',
    padding: '22px 22px 22px 30px',
  },
  commodityHSCodeForm: {
    ...common.flexInline,
    alignItems: 'flex-start',
    flex: 1,
    columnGap: '0.5rem',
    flexWrap: 'wrap',
  },
}));

export interface CommodityDisplayProps {
  commodity?: Commodity;
  onPhotosPreview?: () => void;
  deletable?: boolean;
  onDelete?: () => void;
  type?: 'client' | 'admin';
}

export const CommodityDisplay: React.FC<CommodityDisplayProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { commodity, onPhotosPreview, deletable = false, onDelete, type = 'client' } = props;

  return (
    <div className={classes.container}>
      <div className={classes.mainCol}>
        <ManagementFieldDisplay
          label={commodityStrings.commodity_no}
          value={commodity?.commodity_no || '-'}
        />
        <ManagementFieldDisplay
          label={commodityStrings.name_en}
          value={commodity?.name_en || '-'}
        />
        <ManagementFieldDisplay
          label={commodityStrings.name_ja}
          value={commodity?.name_ja || '-'}
        />
        <ManagementFieldDisplay
          label={commodityStrings.url}
          value={commodity?.url || '-'}
          classes={{ value: classes.wordBreakBreakAll }}
        />
        <ManagementFieldDisplay
          label={commodityStrings.material}
          value={commodity?.material || '-'}
        />
        <ManagementFieldDisplay label={commodityStrings.usage} value={commodity?.usage || '-'} />
        <ManagementFieldDisplay
          label={commodityStrings.explanation}
          value={commodity?.explanation || '-'}
        />
        <ManagementFieldDisplay label={commodityStrings.memo} value={commodity?.memo || '-'} />
        {type === 'client' && (
          <ManagementFieldDisplay
            label={commodityStrings.hs_code}
            value={commodity?.hs_code || commodityStrings.d2dStaffFill}
          />
        )}
      </div>
      <div className={classes.previewBoxCol}>
        {deletable && (
          <IconButton
            onClick={onDelete}
            aria-label="close"
            style={{ padding: 0, marginBottom: '1rem' }}
          >
            <CloseIcon />
          </IconButton>
        )}

        {commodity && (
          <CommodityPhotoCover
            commodity={commodity}
            width={200}
            height={188}
            border={true}
            countBoxHeight={26}
            onClick={() => !!commodity?.images.length && onPhotosPreview?.()}
          />
        )}
      </div>
    </div>
  );
};
